import { render, staticRenderFns } from "./JobInfoPanel.vue?vue&type=template&id=636642ba&scoped=true&"
import script from "./JobInfoPanel.vue?vue&type=script&lang=js&"
export * from "./JobInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./JobInfoPanel.vue?vue&type=style&index=0&id=636642ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636642ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
